import { render, staticRenderFns } from "./MessageComment.vue?vue&type=template&id=27bb30a2&scoped=true&"
import script from "./MessageComment.vue?vue&type=script&lang=js&"
export * from "./MessageComment.vue?vue&type=script&lang=js&"
import style0 from "./MessageComment.vue?vue&type=style&index=0&id=27bb30a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bb30a2",
  null
  
)

export default component.exports